import dayjs from "dayjs";
import useProductStore from "../store/productStore";
import useRemoveProduct from "../hooks/useRemoveProduct";
import React from "react";
import Ordination from "./Ordination";
import { Link } from "react-router-dom";
import useOrdinationStore from "../store/ordinationStore";
import Product from "../interfaces/product";
import PagedResult from "../interfaces/pagedResult";

const ProductTable = (products: PagedResult<Product>) => {
    const setSelectedProduct = useProductStore(
        (state) => state.setSelectedProduct
    );
    const setPage = useOrdinationStore((state) => state.setPage);

    const { mutate: removeProduct, isPending: loadingRemove } =
        useRemoveProduct();

    const [loadingId, setLoadingId] = React.useState<number | null>(null);

    return (
        <table className="table table-dark table-striped table-bordered mt-5">
            <thead>
                <tr>
                    <th scope="col">
                        Product id{" "}
                        <Ordination field="id" />
                    </th>
                    <th scope="col">Image</th>
                    <th scope="col">
                        Name <Ordination field="name" />
                    </th>
                    <th scope="col">
                        Description{" "}
                        <Ordination
                            field="description"
                           
                        />
                    </th>
                    <th scope="col">
                        Category{" "}
                        <Ordination field="category" />
                    </th>
                    <th scope="col">
                        Posted At{" "}
                        <Ordination field="postedAt" />
                    </th>
                    <th scope="col">
                        Amount{" "}
                        <Ordination field="quantity" />
                    </th>
                    <th scope="col">
                        Price{" "}
                        <Ordination field="price" />
                    </th>
                    <th scope="col">
                        Is limited{" "}
                        <Ordination field="isLimited" />
                    </th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
                {products!.items.map((product) => (
                    <tr key={product.id}>
                        <td>{product.id}</td>
                        <td>
                            <img
                                key={product.id}
                                src={`/assets/${product.pathImage}`}
                                alt={product.name}
                                style={{ width: "100px" }}
                            />
                        </td>
                        <td>
                            <Link to={`/product/${product.id}`}>
                                {product.name}
                            </Link>
                        </td>
                        <td>{product.description}</td>
                        <td>{product.category.name}</td>
                        <td>{dayjs(product.postedAt).format("DD/MM/YYYY")}</td>
                        <td>{product.quantity}</td>
                        <td>{product.price}</td>
                        <td>{product.limitedAmount ? "True" : "False"}</td>
                        <td>
                            <button
                                className="btn btn-warning mr-2"
                                onClick={() => setSelectedProduct(product)}
                            >
                                Edit
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={() => {
                                    setLoadingId(product.id!);
                                    removeProduct(product.id!, {
                                        onSuccess: () => {
                                            setLoadingId(null);
                                            setPage(0);
                                        },
                                        onError: () => setLoadingId(null),
                                    });
                                }}
                                disabled={
                                    loadingRemove && loadingId === product.id
                                }
                            >
                                {loadingRemove && loadingId === product.id ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    "Remove"
                                )}
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default ProductTable;
